module.exports = __webpack_public_path__ + "d27cfc117ebf79caf632e883b409d2c6.svg";